import React from 'react';
const serverUrl = "/api";
class GameContentProvider extends React.Component {


    async getGames(city, lang) {

        let token;
        token = localStorage.getItem('token');
        if (!token) {
            token = localStorage.getItem('guest_token');
        }

        try {
            const response = await fetch(serverUrl + `/games`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    city: city,
                    token: token,
                    lang: lang,
                }),
            });
            if (!response.ok) {
                throw new Error('Failed to fetch game details');
            }

            const games = await response.json();
            return games;
        } catch (error) {
            console.error('Error fetching game details:', error);
            return null; // You can handle errors based on your requirements
        }
    }

    async getGameDetails(title, lang) {

        let token;
        token = localStorage.getItem('token');
        if (!token) {
            token = localStorage.getItem('guest_token');
        }
        console.log(title, token, lang);
        try {
            const response = await fetch(serverUrl + `/gamedetails`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    gameTitle: title,
                    token: token,
                    lang: lang,
                }),
            });

            console.log(response);
            if (!response.ok) {
                throw new Error('Failed to fetch game details');
            }

            const gameData = await response.json();
            return gameData;
        } catch (error) {
            console.error('Error fetching game details:', error);
            return null; // You can handle errors based on your requirements
        }
    }

    async getAvailableCities() {
        try {
            const response = await fetch(serverUrl + '/cities'); // Assuming the endpoint for fetching cities is '/cities'
            if (!response.ok) {
                throw new Error('Failed to fetch available cities');
            }
            const cities = await response.json();
            return cities;
        } catch (error) {
            console.error('Error fetching available cities:', error);
            throw error; // Rethrow the error for handling in the caller
        }
    }

    async submitSurvey(data) {
        try {
            const response = await fetch(serverUrl + '/submit-survey', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error('Failed to submit survey');
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Error submitting survey:', error);
            throw error; // Rethrow the error for handling in the caller
        }
    }

    async checkSurveySubmited(token, gameId) {
        console.log("checkSurveySubmited");
        try {
            const response = await fetch(serverUrl + '/check-survey-submited', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token,
                    gameId: gameId
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to check survey');
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Error checking survey:', error);
            throw error; // Rethrow the error for handling in the caller
        }
    }




    async useHint(playId, step) {
        try {
            const response = await fetch(serverUrl + '/use-hint', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    play_id: playId,
                    step: step
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to use hint');
            }
            return await response.json();
        } catch (error) {
            console.error('Error using hint:', error);
            return null;
        }
    }

    async getStepDetails(game, step, lang, playId) {
        try {
            const response = await fetch(serverUrl + `/steps`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    lang: lang,
                    game: game,
                    step: step,
                    play: playId,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch step details');
            }

            const stepData = await response.json();
            return stepData;
        } catch (error) {
            console.error('Error fetching step details:', error);
            return null; // You can handle errors based on your requirements
        }
    }

    async getCurrentStep(playId, token) {
        console.log("getCurrentStep", playId, token);
        try {
            // 1. Changed to match your backend route (removed /api/ if you don't use it)
            const response = await fetch(serverUrl + `/current-step`, {
                method: 'POST', // 2. Changed to POST
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Keep this if your server checks tokens
                },
                // 3. Put the play_id in the body exactly how your backend expects it
                body: JSON.stringify({ play_id: playId })
            });

            const data = await response.json();
            // 4. Your backend returns an array like [{ last_step: 3 }]
            // We check if the array exists, and grab the last_step from the first item
            if (data && data.length > 0 && data[0].last_step !== undefined) {
                return [data[0].last_step, data[0].completed, data[0].is_paused, data[0].paused_overlay];
            } else {
                return null;
            }
        } catch (error) {
            console.error('Error in getCurrentStep:', error);
            return null;
        }
    }




    async getRanking(team_game_id) {
        try {
            const response = await fetch(serverUrl + `/ranking`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    team_game_id: team_game_id,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch step details');
            }

            const rankingData = await response.json();
            return rankingData;
        } catch (error) {
            console.error('Error fetching step details:', error);
            return null; // You can handle errors based on your requirements
        }
    }


    async getReferralPoints(token) {
        try {
            const response = await fetch(serverUrl + `/referralPoints`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token,
                }),
            });
            if (!response.ok) {
                throw new Error('Failed to fetch step details');
            }

            const referralPoints = await response.json();


            if (referralPoints && referralPoints[0] && referralPoints[0].referral_points !== undefined) {
                console.log(referralPoints[0].referral_points);
                return referralPoints[0].referral_points;
            } else {
                console.log("null");
                return null;
            }
        } catch (error) {
            console.error('Error fetching step details:', error);
            return null; // You can handle errors based on your requirements
        }
    }

    async startGame(gameId, teamName, coupon, token) {
        console.log(gameId, teamName, coupon, token);

        try {
            const response = await fetch(serverUrl + '/playgame', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    gameId: gameId,
                    teamName: teamName,
                    coupon: coupon,
                    step: 1,
                    token: token,
                }),
            });

            if (response.ok) {
                const data = await response.json();

                // Check if the response is an array
                if (Array.isArray(data) && data.length > 0) {
                    // Access the first element of the array
                    const insertedRow = data[0].inserted_row;

                    // Check if 'inserted_row' exists in the response
                    if (insertedRow) {
                        console.log('Server response:', insertedRow);
                        return insertedRow;
                    } else {
                        console.error('Invalid server response:', data);
                        return null;
                    }
                } else {
                    console.error('Invalid server response:', data);
                    return null;
                }
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    };

    async startTeamGame(gameId, teamName, coupon, selectedDateTime, token) {
        console.log(gameId, teamName, coupon, selectedDateTime, token);

        try {
            const response = await fetch(serverUrl + '/playTeamGame', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    gameId: gameId,
                    teamName: teamName,
                    coupon: coupon,
                    selectedDateTime: selectedDateTime,
                    step: 1,
                    token: token,
                }),
            });

            if (response.ok) {
                const data = await response.json();

                // Check if the response is an array
                if (Array.isArray(data) && data.length > 0) {
                    // Access the first element of the array
                    const insertedRow = data[0].inserted_row;

                    // Check if 'inserted_row' exists in the response
                    if (insertedRow) {
                        console.log('Server response:', insertedRow);
                        return insertedRow;
                    } else {
                        console.error('Invalid server response:', data);
                        return null;
                    }
                } else {
                    console.error('Invalid server response:', data);
                    return null;
                }
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    };

    async getTeams(code) {
        console.log(code);

        try {
            const response = await fetch(serverUrl + '/getTeams', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    code: code,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log(data);

                // Check if the response is an array
                if (Array.isArray(data) && data.length > 0) {
                    return data;
                } else {
                    console.error('Invalid server response:', data);
                    return null;
                }
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    };

    async addTeam(teamGameId, newName, token) {
        try {
            const response = await fetch(serverUrl + '/addTeam', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    teamGameId: teamGameId,
                    teamName: newName,
                    token: token,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log(data);

                return data;
            } else {
                console.error('Server error:', response.statusText);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    };


    async checkCode(code, token) {
        try {
            const response = await fetch(serverUrl + '/checkCode', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    code: code,
                    token: token,
                }),
            });
            if (response.status == 429) {
                return [null, 429];
            }

            if (response.ok) {

                const data = await response.json();
                console.log(data);

                return [data, 1];
            } else {
                console.error('Server error:', response.statusText);
                return [null, -1];
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return [null, -1];
        }
    };


    async checkCoupon(couponCode, token, lang) {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/coupons`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    coupon: couponCode,
                    token: token,
                    lang: lang,
                }),
            });


            //console.log(response);
            if (!response.ok) {
                console.log(response.status);
                if (response.status == 429) {
                    return [null, 429];
                }
                throw new Error('Failed to fetch coupon data', response.status);
            }

            const result = await response.json();
            console.log(result);
            if (result && result[0] && result[0].coupon) {
                const couponData = result[0];
                console.log(couponData);
                // Perform coupon validation based on fetched data
                return [couponData, 1];
            } else {
                console.error('Error fetching coupon data');
                return [null, -1];
            }
        } catch (error) {
            console.error('Error fetching coupon data:', error);
            return [null, -1];
        }
    };


    async registerGuest() {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/registerGuest`);
            if (!response.ok) {
                throw new Error('Failed to fetch coupon data');
            }

            const token = await response.json();
            console.log(token);
            return token
        } catch (error) {
            console.error('Error fetching coupon data:', error);
            return null;
        }
    };

    async checkTeamMember(usertoken, gameId) {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/checkTeamMember`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: usertoken,
                    gameId: gameId,
                }),
            });
            if (!response.ok) {
                throw new Error('Failed to fetch coupon data');
            }

            const data = await response.json();
            console.log(data);
            if (!data) {
                throw new Error('Failed to fetch coupon data');
            }


            return data;
        } catch (error) {
            console.error('Error fetching coupon data:', error);
            return null;
        }
    };






    async joinTeam(teamID, user_token) {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/joinTeam`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    teamID: teamID,
                    token: user_token,
                }),
            });

            console.log(response);

            if (!response.ok) {
                throw new Error('Failed to fetch coupon data');
            }

            const token = await response.json();
            console.log(token);
            return token
        } catch (error) {
            console.error('Error fetching coupon data:', error);
            return null;
        }
    };

    async getUserGames(user_token, lang) {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/getUserGames`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: user_token,
                    lang: lang
                }),
            });

            console.log(response);

            if (!response.ok) {
                throw new Error('Failed to fetch coupon data');
            }

            const result = await response.json();
            console.log(result);
            return result
        } catch (error) {
            console.error('Error fetching coupon data:', error);
            return null;
        }
    };

    async stepCompleted(step, user_token, playId) {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/stepCompleted`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    step: step,
                    token: user_token,
                    playId: playId,
                }),
            });

            console.log(response);

            if (!response.ok) {
                throw new Error('Failed to fetch coupon data');
            }

            const result = await response.json();
            console.log(result);
            return result
        } catch (error) {
            console.error('Error fetching coupon data:', error);
            return null;
        }
    };

    async skipStep(step, user_token, playId) {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/skipStep`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    step: step,
                    token: user_token,
                    playId: playId,
                }),
            });

            console.log(response);

            if (!response.ok) {
                throw new Error('Failed to fetch coupon data');
            }

            const result = await response.json();
            console.log(result);
            return result
        } catch (error) {
            console.error('Error fetching coupon data:', error);
            return null;
        }
    };


    async teamStepCompleted(step, user_token, teamGameId, hint_used) {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/teamStepCompleted`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    step: step,
                    token: user_token,
                    teamGameId: teamGameId,
                    hint_used: hint_used,
                }),
            });

            console.log(response);

            if (!response.ok) {
                throw new Error('Failed to fetch coupon data');
            }

            const result = await response.json();
            console.log(result);
            return result
        } catch (error) {
            console.error('Error fetching coupon data:', error);
            return null;
        }
    };

    async getAdminPlayHistory(playId, adminToken, lang) {
        try {
            const response = await fetch(serverUrl + `/admin/playHistory`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-admin-token': adminToken,
                },
                body: JSON.stringify({
                    playId: playId,
                    language: lang,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to fetch admin game history');
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Error fetching admin game history:', error);
            return null;
        }
    };

    async getPlayHistory(playId, token, lang) {
        try {
            // Assuming you have an API endpoint to fetch coupon data
            const response = await fetch(serverUrl + `/getPlayHistory`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    playId: playId,
                    token: token,
                    language: lang,
                }),
            });

            console.log(response);

            if (!response.ok) {
                throw new Error('Failed to fetch coupon data');
            }

            const result = await response.json();
            console.log(result);
            return result
        } catch (error) {
            console.error('Error fetching game history:', error);
            return null;
        }
    };







    async pauseGame(playId, token, overlay) {
        try {
            const response = await fetch(serverUrl + `/pause-game`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    playId: playId,
                    token: token,
                    overlay: overlay,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to pause game');
            }

            return await response.json();
        } catch (error) {
            console.error('Error pausing game:', error);
            return null;
        }
    }

    async resumeGame(playId, token) {
        try {
            const response = await fetch(serverUrl + `/resume-game`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    playId: playId,
                    token: token,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to resume game');
            }

            return await response.json();
        } catch (error) {
            console.error('Error resuming game:', error);
            return null;
        }
    }


    render() {
        // You can include any additional React component logic here if needed
        return null;
    }
}



export default GameContentProvider;
